import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import ApiOptionsConfig from './api-options.config';
import { ApiBaseService } from './api-base.service';

const BASE_URL = '/antivirus-logs';

@Injectable({
  providedIn: 'root'
})
export class AntivirusFileUploadLogService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(antivirusLogId: number, options?: ApiOptionsConfig): Observable<any> {;
    return this.GET(this.getUrl(`${BASE_URL}/${antivirusLogId}`), options?.params);
  }
}
